module.exports = __webpack_public_path__ + "img/accounting.1c59824c.png";